module.exports = __webpack_public_path__ + "media/components/web/pages/index/resources/images/managers/melissa_evrin-f93fcf078603aca38a966d7c43977418.png";